import React from "react";
import { Col, Container, Row } from "reactstrap";
import { contactInfo } from "../Data/ComponentsData/componentsdata";
import ContactForm from "./ContactForm";
 

const Contact = () => {
  return (
    <section className='contact' id='contact'>
      <Container>
        <Row>
          <Col md={6}>
            <div className='section-title'>
              <h2>Get In Touch</h2>
            </div>
             <ContactForm/>
          </Col>
          <Col md={6}>
            <div className='section-title'>
              <h2>Contact Info</h2>
            </div>
            <p>Lorem ipsum dolor sit amet, consecte adipisicing elit sed do eiusmod tempor incididunt.</p>
            <ul className='contact-box'>
              {contactInfo.map((info) => (
                <li key={info.id}>
                  <div className='contact-circle'>{info.icon}</div>
                  <div className='contact-text'>
                    <h3>{info.title}</h3>
                    <p>{info.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
